import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { getLocalizedStrings } from '../../misc';
import request from '../../utils/request';
import { Typography } from '@telus-uds/components-web';
import { CONSTANT } from '../../utils/constant';
import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const getDealershipList = list => {
  const updatedList =
    list &&
    list.length &&
    list.map(dealership => {
      return {
        label: dealership.name,
        value: dealership.name
      };
    });
  return updatedList;
};

const DealerForm = ({ values, labels, touched, errors, setFieldValue }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dealershipList, setDealershipList] = useState([]);
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        REGISTRATION_SCHEMA_MESSAGES: { FETCHING_DEALERSHIP_LIST }
      }
    }
  } = localizedStrings;
  const {
    KEYS: { ROLES }
  } = CONSTANT;
  const {
    USERS: {
      USER_AUTHENTICATION: {
        REGISTRATION_SCHEMA_MESSAGES: { REQUIRES_ORDER_ACCESS_LABEL }
      }
    }
  } = getLocalizedStrings();

  const getDealerships = async () => {
    request.get(`/dealerships`).then(response => {
      setIsLoading(false);
      if (response && response.status === 200) {
        if (response.data && response.data.rows && response.data.rows.length) {
          setDealershipList(getDealershipList(response.data.rows));
        }
      }
    });
  };

  // Getting the List of dealership from contentful
  useEffect(() => {
    getDealerships();
  }, []);

  const changeHandler = selected => {
    setFieldValue('dealership', selected.length ? selected[0].value : '');
  };

  return (
    <>
      <div className="main-content-form-headers" style={{ marginTop: 20 }}>
        <Typography>{labels.SELECT_DEALERSHIP}</Typography>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${errors.dealership && touched.dealership ? 'error' : ''
          }`}
      >
        {isLoading ? (
          <div>{FETCHING_DEALERSHIP_LIST}</div>
        ) : (
          <Typeahead
            id="single-typehead"
            onChange={changeHandler}
            options={dealershipList}
          />
        )}

        <>
          <div className="error_messages">
            <Typography variant={{ colour: 'error' }}>{errors.dealership}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>

      <div className="main-content-form-headers">
        <Typography>
          {labels.CHANNEL_ORGANIZATION_CODE}
        </Typography>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors.channelOrgCode && touched.channelOrgCode ? 'error' : ''
          }`}
      >
        <Field
          type="text"
          placeholder={labels.PLACEHOLDER_CHANNEL_ORGANIZATION_CODE}
          className="select-style"
          name="channelOrgCode"
        />
        <>
          <div className="error_messages">
            <Typography variant={{ colour: 'error' }}>{errors.channelOrgCode}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>

      {values.role === ROLES.SALES_MANAGER && (
        <>
          <div className="main-content-form-headers">
            <span className="select-placeholder">{REQUIRES_ORDER_ACCESS_LABEL}</span>
          </div>
          <div
            style={{ position: 'relative', width: '100%' }}
            className={`frg-select-container color-light input-container ${
              errors.requiresOrderAccess && touched.requiresOrderAccess ? 'error' : ''
            }`}
          >
            <Field as="select" name="requiresOrderAccess" className="select-style">
              <option value="">{labels.SELECT_OPTION}</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Field>
            <>
              <div className="error_messages">
                <span className="registration-error">{errors.requiresOrderAccess}</span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
          {values.requiresOrderAccess === 'yes' && (
            <>
              <div className="main-content-form-headers">
                <span className="select-placeholder">{labels.CPMS_ID}</span>
              </div>
              <div
                style={{ position: 'relative' }}
                className={`input-container ${
                  errors.cpmsId && touched.cpmsId ? 'error' : ''
                }`}
              >
                <Field
                  placeholder={labels.CPMS_ID}
                  className="select-style"
                  name="cpmsId"
                  type="text"
                />
                <>
                  <div className="error_messages">
                    <span className="registration-error">{errors.cpmsId}</span>
                  </div>
                  <div id="username_error_icon" className="error_messages_icon">
                    <img src={ErrorIcon} alt="error_icon" />
                  </div>
                </>
              </div>
            </>
          )}
        </>
      )}

      {/* <div className="main-content-form-headers">
        <span className="select-placeholder"><Typography>{labels.CPMS_ID}</Typography></span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors.salesRepId && touched.salesRepId ? 'error' : ''
          }`}
      >
        <Field
          placeholder={labels.CPMS_ID}
          className="select-style"
          name="salesRepId"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="registration-error"><Typography>{errors.salesRepId}</Typography></span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div> */}
      {/* {values.userRole !== ROLES.SALES_MANAGER && (
        <>
          <div className="main-content-form-headers">
            <span className="select-placeholder"><Typography>{labels.SALE_MANAGER}</Typography></span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.salesManager && touched.salesManager ? 'error' : ''
              }`}
          >
            <Field
              placeholder={labels.PLACEHOLDER_MANAGER}
              name="salesManager"
              className="select-style"
              type="text"
            />
            <>
              <div className="error_messages">
                <span className="registration-error">
                  {errors.salesManager}
                </span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
          <div className="main-content-form-headers">
            <span className="select-placeholder">
              {labels.SALE_MANAGER_EMAIL}
            </span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.salesManagerEmail && touched.salesManagerEmail
              ? 'error'
              : ''
              }`}
          >
            <Field
              placeholder={labels.PLACEHOLDER_MANAGER_EMAIL}
              name="salesManagerEmail"
              className="select-style"
              type="text"
            />
            <>
              <div className="error_messages">
                <span className="registration-error">
                  {errors.salesManagerEmail}
                </span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
        </>
      )} */}
    </>
  );
};

DealerForm.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default DealerForm;
